import React from "react";
import { Container, Row, Col } from 'react-bootstrap';

export default function NumbersBlock() {
    return (
        <section className='padding-section-large'>
            <Container>
                <Row className='mb-4'>
                    <Col md={4}>
                        <h2 className="heading-style-h2 pb-3">Numbers That Reflect <br /><span className="text-gradient-1">Our Work</span></h2>
                    </Col>
                    <Col md={8}>
                        <div className="stats-grid">
                            <div className="card-box small primary-border bg-gradient-1">
                                <h2 class="heading-style-h2 pb-3"><span class="text-gradient-1">17+<br /> Years</span></h2>
                                <p>Delivering resilient software across complex business environments</p>
                            </div>

                            <div className="card-box large bg-gradient-1">
                                <h2 class="heading-style-h2 pb-3"><span class="text-gradient-1">40–50<br /> Specialists</span></h2>
                                <p>A focused team across development, QA and DevOps</p>
                            </div>

                            <div className="card-box large bg-gradient-1">
                                <h2 class="heading-style-h2 pb-3"><span class="text-gradient-1">Global Client Presence</span></h2>
                                <p>A focused team across development, QA and DevOps</p>
                            </div>

                            <div className="card-box small bg-gradient-1">
                                <h2 class="heading-style-h2 pb-3"><span class="text-gradient-1">Long-Term Engagements</span></h2>
                                <p>Partnerships shaped by trust, continuity and consistent delivery</p>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}